import React from 'react';
import type { IHeaderParams } from 'ag-grid-community';
import { Icon } from 'venn-ui-kit';
import { Tooltip, TooltipContentWithArrow, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';
import { Match } from 'effect';

type RangeHeaderComponentProps = IHeaderParams & {
  isHistorical: boolean;
  title: string;
};

export const DateHeaderComponent = ({ column, progressSort, title, isHistorical }: RangeHeaderComponentProps) => {
  const [sortDirection, setSortDirection] = React.useState(column.getSort());
  column.addEventListener('sortChanged', () => {
    setSortDirection(column.getSort());
  });
  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          progressSort();
        }
      }}
      className="flex gap-[3px] cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        progressSort();
      }}
    >
      {title}
      <Tooltip>
        <TooltipTrigger>
          <Icon prefix="far" type="circle-info" iconLabel="Date header info icon" />
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContentWithArrow>
            {isHistorical
              ? 'Based on returns data, allocations, and any applied proxies.'
              : 'Based on returns data and any applied proxies.'}
          </TooltipContentWithArrow>
        </TooltipPortal>
      </Tooltip>

      <span className="ag-sort-indicator-container">
        {Match.value(sortDirection).pipe(
          Match.when('asc', () => <span className="ag-icon ag-icon-asc" />),
          Match.when('desc', () => <span className="ag-icon ag-icon-desc" />),
          Match.orElse(() => null),
        )}
      </span>
    </div>
  );
};
